import { transport } from 'config/transport';

export function callApiUpdateThuDauNam(thuDauNamId, body) {
    return transport.put(`/mamnon/thuhocsinh/thudaunam/${thuDauNamId}`, body);
}
